<template>
  <section
    :style="data.style ? data.style :  isDark ? 'secondary' : ''"
    :class="`${isDark ? 'secondary white--text' : ''}  ${data.class}`"
    id="previews"
  >
    <v-container
      
      :class="`d-none d-lg-block features ${ isDark ? 'white--text' : ''}`"
      id="previews-desktop"
    >
      <v-row justify="center" align="center">
        <v-col cols="11" class="text-center">
          <h1 class="page-heading">{{data.title}}</h1>
          <span v-if="data.description">{{data.description}}</span>
        </v-col>
      </v-row>

      <v-row justify="center" align="center">
        <v-col cols="3" lg="3" xl="3">
          <v-container>
            <v-row>
              <v-col cols="12" v-for="(tile,t) in tilesLeft" :key="`tiles-left-${t}`">
                <preview-tile :value="tile"></preview-tile>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
        <v-col cols="6" lg="6" xl="5">
          <preview-videos :value="data.previews"></preview-videos>
        </v-col>
        <v-col cols="3" lg="3" xl="3">
          <v-container>
            <v-row>
              <v-col cols="12" v-for="(tile,t) in tilesRight" :key="`tiles-right-${t}`">
                <preview-tile :value="tile"></preview-tile>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
    <v-container
      fluid
      :class="`d-block d-lg-none features ${ isDark ? 'white--text' : ''}`"
      id="previews-mobile"
    >
      <v-row justify="center" align="center">
        <v-col cols="12" class="text-center">
          <h3 class="monster">{{data.title}}</h3>
          <span v-if="data.description" class="text-small">{{data.description}}</span>
        </v-col>
      </v-row>

      <v-row justify="center" align="center">
        <v-col cols="12">
          <preview-videos :value="data.previews"></preview-videos>
        </v-col>
        <v-col cols="12">
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" v-for="(tile,t) in value.tiles" :key="`tiles-mobile-${t}`">
                <preview-tile :value="tile"></preview-tile>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import previewTile from "./tile";
import previewVideos from "./videos";

export default {
  name: "PagePreviews",
  props: ["value"],
  data() {
    return {
      selected: null
    };
  },
  created() {
    this.selected = this.value.previews[0];
  },
  components: {
    previewTile,
    previewVideos
  },
  computed: {
    tilesLeft() {
      let halfwayThrough = Math.floor(this.value.tiles.length / 2);
      let arrayFirstHalf = this.value.tiles.slice(0, halfwayThrough);
      return arrayFirstHalf;
    },
    tilesRight() {
      let halfwayThrough = Math.floor(this.value.tiles.length / 2);
      let arraySecondHalf = this.value.tiles.slice(
        halfwayThrough,
        this.value.tiles.length
      );
      return arraySecondHalf;
    },
    data() {
      return this.value;
    },
    isDark() {
      return this.value.dark ? true : false;
    }
  }
};
</script>

<style lang="scss">
.features a {
  text-decoration: none;
}
.icon {
  font-size: 100px;
}

.vx {
  /* Extra small devices (phones, 600px and down) */
  @media only screen and (max-width: 600px) {
    padding: 20px;
  }

  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (min-width: 600px) {
    padding: 20px;
  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
    padding: 10px;
  }

  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) {
    padding: 50px;
  }

  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1200px) {
    padding: 50px;
  }
}
</style>